import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'ROLES_VIEW', {
  TITLE: 'Roles',
  NAME: 'Name',
  GUARD_NAME: 'Guard name',
  ACTIONS: 'Actions',
  EDIT: 'Edit',
  DELETE: 'Delete',
  DELETE_DIALOG_TITLE: 'Delete role',
  DELETE_DIALOG_MESSAGE: 'Are you sure you want to delete the role {{ name }}?',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'ROLES_VIEW', {
  TITLE: 'Roles',
  NAME: 'Nombre',
  GUARD_NAME: 'Nombre de la guardia',
  ACTIONS: 'Acciones',
  EDIT: 'Editar',
  DELETE: 'Eliminar',
  DELETE_DIALOG_TITLE: 'Eliminar rol',
  DELETE_DIALOG_MESSAGE: 'Estás seguro de querer eliminar al rol {{ name }}?',
});
